import { render, staticRenderFns } from "./SearchInsuranceCompanyForm.vue?vue&type=template&id=d8b84ae2"
import script from "./SearchInsuranceCompanyForm.vue?vue&type=script&lang=js"
export * from "./SearchInsuranceCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports